/*
  PaniHome — module de panier.

  Transpose depuis l implementation de reference, dont la logique a fait ses
  preuves en production. Ce qui a ete RETIRE : paliers de recompense, cadeau
  offert, barre de progression, moteur de recommandations, et le contournement
  specifique a WideBundle (application non installee sur PaniHome, verifie).
  Ce qui a ete GARDE : tout le reste, a l identique.

  Principe directeur : AMELIORATION PROGRESSIVE.
  Le site fonctionne sans ce fichier. Les formulaires d ajout sont natifs et
  pointent vers /cart/add, l icone du header est un vrai lien vers /cart. Ce
  module se contente d intercepter ces actions QUAND il y parvient. Toute
  erreur — reseau, JSON, exception — laisse le comportement natif reprendre la
  main plutot que d afficher un panier a moitie fonctionnel.

  Source unique de verite : l API panier de Shopify. Aucun etat parallele.
*/
(function () {
  'use strict';

  var racine = document.querySelector('[data-phcart]');
  if (!racine) return;

  var FORMAT = racine.getAttribute('data-format-monnaie') || '{{amount}} €';
  var URL_PANIER = racine.getAttribute('data-url-panier') || '/cart';

  var liste = racine.querySelector('[data-phcart-liste]');
  var vide = racine.querySelector('[data-phcart-vide]');
  var pied = racine.querySelector('[data-phcart-pied]');
  var compte = racine.querySelector('[data-phcart-compte]');
  var bulle = racine.querySelector('[data-phcart-bulle]');
  var bulleCompte = racine.querySelector('[data-phcart-bulle-compte]');
  var zoneLivraison = racine.querySelector('[data-phcart-livraison]');
  var zoneReco = racine.querySelector('[data-phcart-upsell]');

  var enCours = false;      // anti double-clic / double-ajout
  var dernierFocus = null;

  /* ------------------------------------------------------------------ */
  /* Formatage monetaire                                                 */
  /* ------------------------------------------------------------------ */
  // On reproduit le format de la boutique plutot que d imposer le notre : le
  // total du tiroir doit correspondre au centime pres a celui du paiement.
  // Shopify propose cinq marqueurs de format ; on les gere tous plutot que de
  // supposer lequel est actif.
  function prix(centimes) {
    var n = centimes / 100;
    var grouper = function (entier, sep) {
      return entier.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    };
    var avecDecimales = function (sepDecimal, sepMillier) {
      var parts = n.toFixed(2).split('.');
      return grouper(parts[0], sepMillier) + sepDecimal + parts[1];
    };
    var sansDecimales = function (sepMillier) {
      return grouper(Math.round(n).toString(), sepMillier);
    };
    var valeurs = {
      amount: avecDecimales('.', ','),
      amount_no_decimals: sansDecimales(','),
      amount_with_comma_separator: avecDecimales(',', '.'),
      amount_no_decimals_with_comma_separator: sansDecimales('.'),
      amount_with_apostrophe_separator: avecDecimales('.', String.fromCharCode(39))
    };
    var sortie = FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (tout, cle) {
      return Object.prototype.hasOwnProperty.call(valeurs, cle) ? valeurs[cle] : tout;
    });
    // Aucun marqueur reconnu : on rend un montant brut plutot que rien.
    return sortie === FORMAT ? valeurs.amount_with_comma_separator + ' €' : sortie;
  }

  /* ------------------------------------------------------------------ */
  /* Appels a l API panier                                               */
  /* ------------------------------------------------------------------ */
  function appel(url, corpsRequete) {
    var options = {
      method: corpsRequete ? 'POST' : 'GET',
      // En-tete de reconnaissance : le filet reseau pose plus bas doit
      // pouvoir distinguer nos appels de ceux des applications tierces,
      // sinon il se declencherait sur lui-meme.
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-PaniHome-Panier': '1'
      },
      credentials: 'same-origin'
    };
    if (corpsRequete) options.body = JSON.stringify(corpsRequete);
    return fetch(url, options).then(function (r) {
      if (!r.ok) throw new Error('reponse ' + r.status);
      return r.json();
    });
  }

  var lire = function () { return appel('/cart.js'); };
  var ajouter = function (items) { return appel('/cart/add.js', { items: items }); };
  var changer = function (cle, quantite) {
    return appel('/cart/change.js', { id: cle, quantity: quantite });
  };

  function echapper(t) {
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }

  /* ------------------------------------------------------------------ */
  /* Rendu                                                               */
  /* ------------------------------------------------------------------ */
  function ligne(article) {
    var li = document.createElement('li');
    li.className = 'phcart-article';
    li.setAttribute('data-cle', article.key);

    var image = article.image
      ? article.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')
      : '';

    // La variante n est affichee que si elle existe reellement : Shopify
    // renvoie « Default Title » pour les produits sans declinaison.
    var variante = article.variant_title && article.variant_title !== 'Default Title'
      ? '<span class="phcart-article__variante">' + echapper(article.variant_title) + '</span>'
      : '';

    li.innerHTML =
      '<div class="phcart-article__visuel">' +
        (image ? '<img src="' + image + '" alt="" width="78" height="78" loading="lazy">' : '') +
      '</div>' +
      '<div class="phcart-article__infos">' +
        '<a class="phcart-article__titre" href="' + article.url + '">' + echapper(article.product_title) + '</a>' +
        variante +
        '<div class="phcart-article__bas">' +
          '<div class="phcart-article__quantite">' +
            '<button type="button" data-phcart-qte="-1" aria-label="Diminuer la quantité">−</button>' +
            '<span data-phcart-qte-valeur>' + article.quantity + '</span>' +
            '<button type="button" data-phcart-qte="1" aria-label="Augmenter la quantité">+</button>' +
          '</div>' +
          // final_line_price, jamais le prix catalogue : c est le montant
          // reellement facture, remises comprises.
          '<span class="phcart-article__prix">' + prix(article.final_line_price) + '</span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="phcart-article__retirer" data-phcart-retirer aria-label="Retirer cet article">' +
        '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M3 3l8 8M11 3l-8 8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
      '</button>';
    return li;
  }

  function ecrire(selecteur, texte) {
    var el = racine.querySelector(selecteur);
    if (el) el.textContent = texte;
  }

  // Le compteur du header est un element du theme, pas du tiroir. Kalles le
  // rafraichissait par son propre AJAX, que nous avons desactive : c est donc
  // a nous de le tenir a jour. Sans cela le client ajoute un article, voit une
  // icone a zero, et recommence.
  //
  // t4s-op-0 est la classe d opacite nulle du theme : c est ainsi qu il masque
  // la pastille quand le panier est vide.
  function majCompteurTheme(n) {
    var cibles = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < cibles.length; i++) {
      cibles[i].textContent = n;
      if (n > 0) cibles[i].classList.remove('t4s-op-0');
      else cibles[i].classList.add('t4s-op-0');
    }
  }

  // Reductions appliquees : on reprend les intitules de Shopify plutot que
  // d en inventer. Le client doit lire dans le tiroir exactement ce qu il
  // relira au paiement.
  function rendreReductions(panier) {
    var zone = racine.querySelector('[data-phcart-reductions]');
    if (!zone) return;
    var appliquees = panier.cart_level_discount_applications || [];
    if (!appliquees.length) { zone.hidden = true; zone.innerHTML = ''; return; }
    var html = '';
    for (var i = 0; i < appliquees.length; i++) {
      var d = appliquees[i];
      html += '<div class="phcart__ligne phcart__ligne--reduction">' +
                '<dt>' + echapper(d.title) + '</dt>' +
                '<dd>−' + prix(d.total_allocated_amount) + '</dd>' +
              '</div>';
    }
    zone.innerHTML = html;
    zone.hidden = false;
  }

  /* ------------------------------------------------------------------ */
  /* Suggestions                                                         */
  /* ------------------------------------------------------------------ */
  // Ce catalogue ne vend que des couchages : il n y a pas d accessoire a
  // poser par-dessus. Les seuls vrais complements sont un couchage POUR
  // AILLEURS — la voiture, le transport, un tapis d appoint dans une autre
  // piece. C est ce que ces familles decrivent, en metier plutot qu en
  // algorithme. Les collections vides du catalogue (housses, velo,
  // plastique) en sont volontairement absentes : pointer une collection
  // vide afficherait un bloc mort.
  var FAMILLES = [
    // Deja un couchage de voiture ou de transport : on propose la maison.
    { motif: /voiture|transport|ceinture|caisse|sac/,
      cibles: ['panier-orthopedique-pour-chien', 'coussin-matelas-chien'] },
    // Deja un tapis ou un matelas : on propose un vrai panier a rebords.
    { motif: /tapis|matelas/,
      cibles: ['panier-orthopedique-pour-chien', 'panier-voiture-chien'] },
    // Cas courant : un panier de maison. La voiture et le transport sont
    // les seuls complements sinceres.
    { motif: /panier|coussin|niche|sofa|nid/,
      cibles: ['panier-voiture-chien', 'panier-transport-chien', 'coussin-matelas-chien'] }
  ];

  var cacheCollections = {};
  var cacheRelated = {};
  var recoEnCours = false;

  function familleDe(panier) {
    var texte = '';
    for (var i = 0; i < panier.items.length; i++) {
      texte += ' ' + (panier.items[i].handle || '') + ' ' + (panier.items[i].product_title || '');
    }
    texte = texte.toLowerCase();
    for (var f = 0; f < FAMILLES.length; f++) {
      if (FAMILLES[f].motif.test(texte)) return FAMILLES[f];
    }
    return null;
  }

  // Normalise une liste de produits de l API storefront.
  function normaliser(liste) {
    var sortie = [];
    for (var i = 0; i < (liste || []).length; i++) {
      var prod = liste[i];
      // Premiere variante DISPONIBLE, pas la premiere tout court : un
      // produit dont la taille de tete est epuisee reste vendable.
      var v = null, dispos = prod.variants || [];
      for (var d = 0; d < dispos.length; d++) { if (dispos[d].available) { v = dispos[d]; break; } }
      if (!v) continue;
      var centimes = Math.round(parseFloat(v.price) * 100);
      if (!centimes) continue;
      var img = '';
      if (prod.images && prod.images[0]) img = prod.images[0].src || prod.images[0];
      else if (prod.featured_image) img = prod.featured_image;
      sortie.push({
        id: prod.id,
        titre: prod.title,
        url: '/products/' + prod.handle,
        image: img,
        variante: v.id,
        centimes: centimes,
        // Toute la promesse de la boutique est de choisir la BONNE taille.
        // Ajouter une taille au hasard parce qu elle est la premiere
        // disponible fabriquerait des retours : des qu il y a un choix a
        // faire, on envoie sur la fiche.
        choixRequis: (prod.variants || []).length > 1
      });
    }
    return sortie;
  }

  function chargerCollection(handle) {
    if (cacheCollections[handle]) return Promise.resolve(cacheCollections[handle]);
    return fetch('/collections/' + handle + '/products.json?limit=12', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { cacheCollections[handle] = normaliser(j.products); return cacheCollections[handle]; })
      .catch(function () { cacheCollections[handle] = []; return []; });
  }

  // Repli : ce que Shopify calcule comme proche de cet article. Ce sont des
  // couchages de substitution, pas des complements — le titre du bloc change
  // en consequence, on ne fait pas passer un autre panier pour un accessoire.
  function chargerRelated(idProduit) {
    if (cacheRelated[idProduit]) return Promise.resolve(cacheRelated[idProduit]);
    return fetch('/recommendations/products.json?product_id=' + idProduit + '&limit=8&intent=related', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { cacheRelated[idProduit] = normaliser(j.products); return cacheRelated[idProduit]; })
      .catch(function () { cacheRelated[idProduit] = []; return []; });
  }

  function ecarterLePanier(candidats, panier) {
    var dedans = {};
    for (var i = 0; i < panier.items.length; i++) dedans[panier.items[i].product_id] = true;
    var out = [];
    for (var c = 0; c < candidats.length; c++) {
      if (!dedans[candidats[c].id]) out.push(candidats[c]);
    }
    return out;
  }

  function carteReco(p) {
    var visuel = p.image ? p.image.replace(/(\.[a-z]+)(\?|$)/i, '_112x$1$2') : '';
    // Multi-variantes : un lien vers la fiche, pas un ajout. Mono-variante :
    // rien a choisir, donc ajout direct sans quitter le tiroir.
    var action = p.choixRequis
      ? '<a class="phcart-reco__action" href="' + p.url + '">Choisir</a>'
      : '<button type="button" class="phcart-reco__action" data-phcart-reco="' + p.variante + '">Ajouter</button>';
    return '<li class="phcart-reco">' +
      (visuel ? '<a class="phcart-reco__visuel" href="' + p.url + '"><img src="' + echapper(visuel) + '" alt="" loading="lazy" width="56" height="56"></a>' : '') +
      '<div class="phcart-reco__infos">' +
        '<a class="phcart-reco__titre" href="' + p.url + '">' + echapper(p.titre) + '</a>' +
        '<span class="phcart-reco__prix">' + prix(p.centimes) + '</span>' +
      '</div>' + action +
    '</li>';
  }

  function cacherReco() {
    if (!zoneReco) return;
    zoneReco.hidden = true;
    zoneReco.innerHTML = '';
  }

  function recommander(panier) {
    if (!zoneReco) return Promise.resolve();
    if (!panier.item_count) { cacherReco(); return Promise.resolve(); }

    var famille = familleDe(panier);
    var cibles = famille ? famille.cibles : [];

    var accumule = [];
    var suite = Promise.resolve();
    cibles.forEach(function (handle) {
      suite = suite.then(function () {
        // Collection suivante sollicitee seulement si le vivier reste maigre.
        if (ecarterLePanier(accumule, panier).length >= 2) return;
        return chargerCollection(handle).then(function (l) { accumule = accumule.concat(l); });
      });
    });

    return suite.then(function () {
      var retenus = ecarterLePanier(accumule, panier);
      if (retenus.length >= 2) return { liste: retenus.slice(0, 2), complement: true };
      return chargerRelated(panier.items[0].product_id).then(function (l) {
        var mix = ecarterLePanier(accumule.concat(l), panier);
        // Le titre ne dit « complement » que si TOUT ce qui est montre vient
        // des collections complementaires.
        return { liste: mix.slice(0, 2), complement: retenus.length >= mix.slice(0, 2).length && retenus.length > 0 };
      });
    }).then(function (res) {
      if (!res.liste.length) { cacherReco(); return; }
      var titre = res.complement ? 'Complétez son confort' : 'À voir aussi';
      var html = '<p class="phcart__upsell-titre">' + titre + '</p><ul class="phcart__recos" role="list">';
      for (var i = 0; i < res.liste.length; i++) html += carteReco(res.liste[i]);
      zoneReco.innerHTML = html + '</ul>';
      zoneReco.hidden = false;
    }).catch(function () { cacherReco(); });
  }

  function ajouterReco(varianteId, bouton) {
    if (recoEnCours) return;
    recoEnCours = true;
    if (bouton) { bouton.disabled = true; bouton.textContent = '...'; }
    ajouter([{ id: varianteId, quantity: 1 }])
      .then(function () { return lire().then(rendre); })
      // Echec : la fiche produit reste un chemin d achat valable.
      .catch(function () { window.location.href = URL_PANIER; })
      .then(function () { recoEnCours = false; });
  }

  function rendre(panier) {
    if (!panier) return;
    var n = panier.item_count;

    if (compte) compte.textContent = n ? ' (' + n + ')' : '';
    majCompteurTheme(n);

    // La pastille suit le panier : elle apparait au premier article et
    // disparait quand il n en reste plus.
    if (bulle) bulle.hidden = !n;
    if (bulleCompte) bulleCompte.textContent = n || '';
    liste.innerHTML = '';

    if (!n) {
      if (vide) vide.hidden = false;
      if (pied) pied.hidden = true;
      // Panier vide : ni bandeau ni suggestions. Le bandeau parlerait d une
      // commande qui n existe pas encore.
      if (zoneLivraison) zoneLivraison.hidden = true;
      cacherReco();
      return;
    }
    if (zoneLivraison) zoneLivraison.hidden = false;
    if (vide) vide.hidden = true;
    if (pied) pied.hidden = false;

    for (var i = 0; i < panier.items.length; i++) liste.appendChild(ligne(panier.items[i]));

    ecrire('[data-phcart-total]', prix(panier.total_price));
    ecrire('[data-phcart-cta-total]', '· ' + prix(panier.total_price));

    rendreReductions(panier);
    recommander(panier);
  }

  /* ------------------------------------------------------------------ */
  /* Ouverture / fermeture                                               */
  /* ------------------------------------------------------------------ */
  function ouvrir() {
    dernierFocus = document.activeElement;
    racine.classList.add('is--ouvert');
    racine.setAttribute('aria-hidden', 'false');
    document.body.classList.add('phcart-ouvert');
    var f = racine.querySelector('[data-phcart-fermer]');
    if (f) f.focus();
  }

  function fermer() {
    racine.classList.remove('is--ouvert');
    racine.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('phcart-ouvert');
    if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
  }

  function rafraichirPuisOuvrir() {
    return lire().then(function (p) { rendre(p); ouvrir(); });
  }

  /* ------------------------------------------------------------------ */
  /* Interception — delegation globale, jamais de liaison par element     */
  /* ------------------------------------------------------------------ */
  // Kalles pose ses propres gestionnaires sur le CLIC des boutons d ajout, et
  // fait son appel reseau sans jamais laisser le formulaire emettre
  // d evenement submit. On se place donc en phase de CAPTURE sur le document,
  // qui s execute avant tout gestionnaire pose plus bas dans l arbre, et on
  // stoppe la propagation pour rester seul maitre du panier.
  //
  // Le bouton de paiement express est volontairement exclu : il mene
  // directement au paiement, ce n est pas un ajout au panier.
  document.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible || !cible.closest) return;
    if (cible.closest('.shopify-payment-button')) return;

    var bouton = cible.closest('[name="add"], [data-atc-form], button[type="submit"]');
    if (!bouton) return;
    var form = bouton.form || bouton.closest('form');
    if (!form || !form.action || form.action.indexOf('/cart/add') < 0) return;
    if (!formulairePret(form)) return;

    e.preventDefault();
    e.stopPropagation();
    soumettre(form);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') < 0) return;
    if (!formulairePret(form)) return;
    if (enCours) { e.preventDefault(); return; }
    e.preventDefault();
    soumettre(form);
  }, true);

  // Un formulaire d ajout sans identifiant de variante n est pas encore
  // pret : la fiche produit laisse le champ vide tant que toutes les options
  // ne sont pas choisies. On ne prend alors PAS la main, pour que la
  // validation du theme puisse s exprimer normalement.
  function formulairePret(form) {
    try {
      return new FormData(form).getAll('id').filter(function (v) { return v; }).length > 0;
    } catch (e) { return false; }
  }

  function soumettre(form) {
    if (enCours) return;
    var donnees = new FormData(form);

    var identifiants = donnees.getAll('id').filter(function (v) { return v; });
    var quantites = donnees.getAll('quantity').filter(function (v) { return v; });

    // Sans identifiant de variante on ne tente rien : le navigateur saura
    // faire mieux que nous avec le formulaire natif.
    if (!identifiants.length) { form.__phRepli = true; form.submit(); return; }

    // Les proprietes de ligne s appliquent a toutes les variantes du
    // formulaire, comme le fait Shopify avec ce format.
    var proprietes = null;
    donnees.forEach(function (valeur, cle) {
      if (cle.indexOf('properties[') === 0) {
        proprietes = proprietes || {};
        proprietes[cle.slice(11, -1)] = valeur;
      }
    });

    var items = identifiants.map(function (id, rang) {
      // Une seule quantite pour plusieurs variantes : elle vaut pour toutes.
      var brute = quantites.length > 1 ? quantites[rang] : quantites[0];
      var article = { id: id, quantity: parseInt(brute, 10) || 1 };
      if (proprietes) article.properties = proprietes;
      return article;
    });

    enCours = true;
    verrouiller(form, true);

    ajouter(items)
      .then(rafraichirPuisOuvrir)
      .catch(function () {
        // Echec reseau ou refus du serveur : on rend la main au comportement
        // natif plutot que de laisser le visiteur bloque. Le marqueur evite
        // que le detournement de submit() nous renvoie ici en boucle.
        form.__phRepli = true;
        form.submit();
      })
      .then(function () { enCours = false; verrouiller(form, false); });
  }

  function verrouiller(form, etat) {
    var b = form.querySelector('[type="submit"], [name="add"]');
    if (b) { b.disabled = etat; b.classList.toggle('is--chargement', etat); }
  }

  // Icone panier du header : reste un vrai lien vers /cart dans le HTML, on
  // n annule la navigation qu au moment du clic. Comme pour l ajout, Kalles
  // pose son propre gestionnaire sur ce lien pour ouvrir SON tiroir : on passe
  // donc en capture et on coupe la propagation, sinon les deux tiroirs
  // s ouvriraient l un sur l autre.
  //
  // Clic milieu, Cmd/Ctrl/Maj : on ne touche a rien, le visiteur veut un
  // nouvel onglet et doit l obtenir.
  document.addEventListener('click', function (e) {
    var lien = e.target.closest ? e.target.closest('a[href$="/cart"], a[href*="/cart?"]') : null;
    if (!lien) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    rafraichirPuisOuvrir().catch(function () { window.location.href = URL_PANIER; });
  }, true);

  // Quantites, suppression, fermeture, pastille.
  racine.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible.closest) return;

    if (cible.closest('[data-phcart-fermer]') || cible.closest('[data-phcart-voile]')) {
      fermer();
      return;
    }
    if (cible.closest('[data-phcart-bulle]')) {
      rafraichirPuisOuvrir().catch(function () { window.location.href = URL_PANIER; });
      return;
    }

    var reco = cible.closest('[data-phcart-reco]');
    if (reco) {
      ajouterReco(reco.getAttribute('data-phcart-reco'), reco);
      return;
    }

    var art = cible.closest('[data-cle]');
    if (!art) return;
    var cle = art.getAttribute('data-cle');

    if (cible.closest('[data-phcart-retirer]')) {
      majQuantite(cle, 0);
      return;
    }
    var bouton = cible.closest('[data-phcart-qte]');
    if (bouton) {
      var actuel = parseInt(art.querySelector('[data-phcart-qte-valeur]').textContent, 10) || 1;
      majQuantite(cle, actuel + parseInt(bouton.getAttribute('data-phcart-qte'), 10));
    }
  });

  function majQuantite(cle, quantite) {
    if (enCours) return;
    enCours = true;
    racine.classList.add('is--occupe');
    changer(cle, Math.max(0, quantite))
      .then(rendre)
      .catch(function () { window.location.href = URL_PANIER; })
      .then(function () { enCours = false; racine.classList.remove('is--occupe'); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (racine.classList.contains('is--ouvert')) fermer();
  });

  /* ------------------------------------------------------------------ */
  /* Filet reseau                                                        */
  /* ------------------------------------------------------------------ */
  // Une application tierce peut ecrire dans le panier sans passer par un
  // formulaire. Sans ce filet, le tiroir afficherait un etat perime.
  var CHEMINS_PANIER = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CHEMIN_AJOUT = /\/cart\/add/;

  function estNotreAppel(options) {
    try {
      var h = options && options.headers;
      if (!h) return false;
      if (typeof h.get === 'function') return !!h.get('X-PaniHome-Panier');
      return !!h['X-PaniHome-Panier'];
    } catch (e) { return false; }
  }

  function reagirAuChangement(estUnAjout) {
    // Un court delai laisse l application qui vient d ecrire finir son
    // travail : certaines enchainent add puis change pour poser une propriete
    // de ligne, et lire trop tot afficherait un panier a moitie constitue.
    if (estUnAjout) reagirAuChangement.ouvrir = true;
    clearTimeout(reagirAuChangement.minuteur);
    reagirAuChangement.minuteur = setTimeout(function () {
      var ouvrirLeTiroir = reagirAuChangement.ouvrir;
      reagirAuChangement.ouvrir = false;
      if (ouvrirLeTiroir) {
        rafraichirPuisOuvrir().catch(function () { /* le lien natif reste */ });
      } else {
        lire().then(rendre).catch(function () { /* rien de visible a faire */ });
      }
    }, 220);
  }

  var fetchOrigine = window.fetch;
  if (typeof fetchOrigine === 'function') {
    window.fetch = function (entree, options) {
      var url = typeof entree === 'string' ? entree : (entree && entree.url) || '';
      var promesse = fetchOrigine.apply(this, arguments);
      if (CHEMINS_PANIER.test(String(url)) && !estNotreAppel(options)) {
        var estUnAjout = CHEMIN_AJOUT.test(String(url));
        promesse.then(function (r) {
          if (r && r.ok) reagirAuChangement(estUnAjout);
        }).catch(function () { /* l appelant gere son propre echec */ });
      }
      return promesse;
    };
  }

  // Certaines applications passent encore par XMLHttpRequest.
  var ouvrirXHR = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    this.__phUrlPanier = CHEMINS_PANIER.test(String(url || ''));
    this.__phEstAjout = CHEMIN_AJOUT.test(String(url || ''));
    return ouvrirXHR.apply(this, arguments);
  };
  var envoyerXHR = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var requete = this;
    if (requete.__phUrlPanier) {
      requete.addEventListener('load', function () {
        if (requete.status >= 200 && requete.status < 300) reagirAuChangement(requete.__phEstAjout);
      });
    }
    return envoyerXHR.apply(this, arguments);
  };

  // Dernier trou : form.submit() appele par un script ne declenche AUCUN
  // evenement submit, il quitte donc la page vers /cart sans que rien ne
  // puisse l intercepter. On detourne les seuls formulaires d ajout.
  var soumettreOrigine = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    var action = this.getAttribute('action') || '';
    if (action.indexOf('/cart/add') >= 0 && !this.__phRepli) {
      soumettre(this);
      return;
    }
    return soumettreOrigine.apply(this, arguments);
  };

  racine.setAttribute('aria-hidden', 'true');

  // Etat initial : on peuple le tiroir sans l ouvrir, pour que le compteur et
  // les totaux soient justes des le premier clic.
  lire().then(rendre).catch(function () { /* le lien natif suffit */ });
})();
